export class DataSource {
    Id: string;
    TextField: string;
    ValueField: string;
    IsSelected: boolean;
}

